import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from "react-router";
import ProductUseimg from "Images/profile/Product-Guide.png";
import RDHubImg from "Images/profile/RD-Hub.png";
import ExploreAllImg from "Images/profile/Explore-All.png";
import CheckInQuizImg from "Images/profile/Complete-Check-In.png";
import HubCard from "../../RDPageV2/RdHub/HubCard";
import { useSelector } from "react-redux";
import styles from "./styles.module.scss";
import H3Font from "../../common/H3Font";
const AccountGetStartedSection = () => {
    const history = useHistory();
    const rdCheckInCompleted = useSelector((state) => state.user.rd_check_in_completed);
    const data = [
        {
            title: "View Product Use Guide",
            onClick: () => history.push("/app/howtolp/"),
            img: ProductUseimg,
            className: "account_hub_card",
            imgClassName: styles.product_use_image,
        },
        {
            title: "Visit the RD Hub",
            onClick: () => history.push("/app/dietitian/"),
            img: RDHubImg,
            className: "account_hub_card",
            imgClassName: styles.hub_image,
        },
        {
            title: "Explore All Products",
            onClick: () => history.push("/app/products/"),
            img: ExploreAllImg,
            className: "account_hub_card",
            imgClassName: styles.hub_image,
        },
        {
            title: "Complete RD Check-In",
            onClick: () => {
                window.location.href = "/quiz-new/quiz_rd";
            },
            img: CheckInQuizImg,
            className: "account_hub_card",
            imgClassName: styles.hub_image,
            rdQuiz: true,
        },
    ];
    return (_jsxs("div", { className: styles.get_started, children: [_jsx(H3Font, { children: "Get Started with Gainful" }), _jsx("div", { className: styles.tile_wrapper, children: data.map((item) => (_jsx(HubCard, { ...item, isCompleted: item.rdQuiz && rdCheckInCompleted }, item.title))) })] }));
};
export default AccountGetStartedSection;
